import abi from './abi.json'
const address = "0xc2132D05D31c914a87C6611C10748AEb04B58e8F"
const usdt = {abi,address}
export default usdt